// Common fields structure can be reused for B and Q, distinct for BBQ.

// Adult (B)
export const BASI_BRADEN_RISK_SCORE = {
    title: "basi-braden.pressure-sore-risk-braden",
    masterTableName: "MC_PRES_SORE_RISK_BRADEN",

    tableName: "MC_PRES_SORE_RISK_BRADEN_DET",
    columnName: "PSRB_ID",
    columnValue: 0,
    formData: {
        PSRB_ID: "",
        PROCESS_TIME: new Date(),
        NURSE_ID: "",
        SENSORY_ASSESSMENT_ID: "",
        SKIN_MOISTURE_CONDITION_ID: "",
        MOVEMENT_ABILITY_ID: "",
        PHYSICAL_ACTIVITY_ID: "",
        NUTRITION_ID: "",
        FRICTION_PRESSURE_ID: "",
        PERFUSION_OXYGENATION_ID: "", // Visible False in Delphi but field exists
        RISK_ASSESSMENT_ID: "",
        CALC_VALUE: "",
        CTIME: new Date(),
        CUSER: "",
        PRESSURE_WOUND_RATE_ID: "",
        PRESS_SCORE_AREA_ID: "",
        IS_BRADEN: "",
        NOTE: "",
    },
    mcpConfig: {
        SENSORY_ASSESSMENT_ID: { mcpId: 1, field: "SENSORY_ASSESSMENT_ID", scoreField: "SENSORY_ASSESSMENT_SCORE" }, // 1
        SKIN_MOISTURE_CONDITION_ID: { mcpId: 2, field: "SKIN_MOISTURE_CONDITION_ID", scoreField: "SKIN_MOISTURE_CONDITION_SCORE" }, // 2
        MOVEMENT_ABILITY_ID: { mcpId: 3, field: "MOVEMENT_ABILITY_ID", scoreField: "MOVEMENT_ABILITY_SCORE" }, // 3
        PHYSICAL_ACTIVITY_ID: { mcpId: 4, field: "PHYSICAL_ACTIVITY_ID", scoreField: "PHYSICAL_ACTIVITY_SCORE" }, // 4
        NUTRITION_ID: { mcpId: 5, field: "NUTRITION_ID", scoreField: "NUTRITION_SCORE" }, // 5
        FRICTION_PRESSURE_ID: { mcpId: 6, field: "FRICTION_PRESSURE_ID", scoreField: "FRICTION_PRESSURE_SCORE" }, // 6
        RISK_ASSESSMENT_ID: { mcpId: 7, field: "RISK_ASSESSMENT_ID", scoreField: "RISK_ASSESSMENT_ID" }, // 7
        PRESSURE_WOUND_RATE_ID: { mcpId: 594, field: "PRESSURE_WOUND_RATE_ID", scoreField: "PRESSURE_WOUND_RATE_ID" }, // 594
        IS_BRADEN: { mcpId: 859, field: "IS_BRADEN", scoreField: "IS_BRADEN" }, // 859
        PRESS_SCORE_AREA_ID: { mcpId: 860, field: "PRESS_SCORE_AREA_ID", scoreField: "PRESS_SCORE_AREA_ID" }, // 860
    },
    fields: [
        { field: "PROCESS_TIME", headerName: "process-time", type: "date", flex: 1 },
        { field: "CUSER", headerName: "createdby", flex: 1 },
        { field: "SENSORY_ASSESSMENT_ID", headerName: "basi-braden.sensory-assessment", flex: 1 },
        { field: "SKIN_MOISTURE_CONDITION_ID", headerName: "basi-braden.skin-moisture-status", flex: 1 },
        { field: "MOVEMENT_ABILITY_ID", headerName: "basi-braden.movement-ability", flex: 1 },
        { field: "PHYSICAL_ACTIVITY_ID", headerName: "basi-braden.physical-activity", flex: 1 },
        { field: "NUTRITION_ID", headerName: "basi-braden.nutrition", flex: 1 },
        { field: "FRICTION_PRESSURE_ID", headerName: "basi-braden.friction-pressure-irritation", flex: 1 },
        // PERFUSION_OXYGENATION_ID removed for Adult as per Delphi Visible=False
        { field: "RISK_ASSESSMENT_ID", headerName: "basi-braden.risk-assessment", flex: 1 },
        { field: "CALC_VALUE", headerName: "score", flex: 1 },
        { field: "PRESSURE_WOUND_RATE_ID", headerName: "basi-braden.pressure-sore-rate", flex: 1 },
        { field: "PRESS_SCORE_AREA_ID", headerName: "basi-braden.pressure-sore-area", flex: 1 },
        { field: "IS_BRADEN", headerName: "basi-braden.pressure-sore", flex: 1 },
        { field: "NOTE", headerName: "note", flex: 1 },
    ],
    rows: [
        { title: "PROCESS_TIME", value: "PROCESS_TIME", type: "date" },
        { title: "CUSER", value: "CUSER" },
        { title: "SENSORY_ASSESSMENT_ID", value: "SENSORY_ASSESSMENT_ID_XNAME" },
        { title: "SKIN_MOISTURE_CONDITION_ID", value: "SKIN_MOISTURE_CONDITION_ID_XNAME" },
        { title: "MOVEMENT_ABILITY_ID", value: "MOVEMENT_ABILITY_ID_XNAME" },
        { title: "PHYSICAL_ACTIVITY_ID", value: "PHYSICAL_ACTIVITY_ID_XNAME" },
        { title: "NUTRITION_ID", value: "NUTRITION_ID_XNAME" },
        { title: "FRICTION_PRESSURE_ID", value: "FRICTION_PRESSURE_ID_XNAME" },
        { title: "RISK_ASSESSMENT_ID", value: "RISK_ASSESSMENT_ID_XNAME" },
        { title: "CALC_VALUE", value: "CALC_VALUE" },
        { title: "PRESSURE_WOUND_RATE_ID", value: "PRESSURE_WOUND_RATE_ID_XNAME" },
        { title: "PRESS_SCORE_AREA_ID", value: "PRESS_SCORE_AREA_ID_XNAME" },
        { title: "IS_BRADEN", value: "IS_BRADEN_XNAME" },
        { title: "NOTE", value: "NOTE" },
    ],
};

// Child (BQ)
export const BASI_BRADEN_RISK_SCORE_Q = {
    title: "basi-braden.modified-braden-q-scale",
    masterTableName: "MC_PRES_SORE_RISK_BRADEN",
    tableName: "MC_PRES_SORE_RISK_BRADEN_DET",
    columnName: "PSRB_ID",
    columnValue: 0,
    formData: {
        PSRB_ID: "",
        PROCESS_TIME: new Date(),
        NURSE_ID: "",
        SENSORY_ASSESSMENT_ID: "",
        SKIN_MOISTURE_CONDITION_ID: "",
        MOVEMENT_ABILITY_ID: "",
        PHYSICAL_ACTIVITY_ID: "",
        NUTRITION_ID: "",
        FRICTION_PRESSURE_ID: "",
        PERFUSION_OXYGENATION_ID: "", // Visible True
        RISK_ASSESSMENT_ID: "",
        CALC_VALUE: "",
        CTIME: new Date(),
        CUSER: "",
        PRESSURE_WOUND_RATE_ID: "",
        PRESS_SCORE_AREA_ID: "",
        IS_BRADEN: "",
        NOTE: "",
    },
    mcpConfig: {
        SENSORY_ASSESSMENT_ID: { mcpId: 11, field: "SENSORY_ASSESSMENT_ID", scoreField: "SENSORY_ASSESSMENT_SCORE" }, // 11
        SKIN_MOISTURE_CONDITION_ID: { mcpId: 12, field: "SKIN_MOISTURE_CONDITION_ID", scoreField: "SKIN_MOISTURE_CONDITION_SCORE" }, // 12
        MOVEMENT_ABILITY_ID: { mcpId: 13, field: "MOVEMENT_ABILITY_ID", scoreField: "MOVEMENT_ABILITY_SCORE" }, // 13
        PHYSICAL_ACTIVITY_ID: { mcpId: 14, field: "PHYSICAL_ACTIVITY_ID", scoreField: "PHYSICAL_ACTIVITY_SCORE" }, // 14
        NUTRITION_ID: { mcpId: 15, field: "NUTRITION_ID", scoreField: "NUTRITION_SCORE" }, // 15
        FRICTION_PRESSURE_ID: { mcpId: 16, field: "FRICTION_PRESSURE_ID", scoreField: "FRICTION_PRESSURE_SCORE" }, // 16
        PERFUSION_OXYGENATION_ID: { mcpId: 17, field: "PERFUSION_OXYGENATION_ID", scoreField: "PERFUSION_OXYGENATION_SCORE" }, // 17
        RISK_ASSESSMENT_ID: { mcpId: 18, field: "RISK_ASSESSMENT_ID", scoreField: "RISK_ASSESSMENT_ID" }, // 18
        PRESSURE_WOUND_RATE_ID: { mcpId: 594, field: "PRESSURE_WOUND_RATE_ID", scoreField: "PRESSURE_WOUND_RATE_ID" }, // 594
        IS_BRADEN: { mcpId: 859, field: "IS_BRADEN", scoreField: "IS_BRADEN" }, // 859
        PRESS_SCORE_AREA_ID: { mcpId: 860, field: "PRESS_SCORE_AREA_ID", scoreField: "PRESS_SCORE_AREA_ID" }, // 860
    },
    fields: [
        { field: "PROCESS_TIME", headerName: "process-time", type: "date", flex: 1 },
        { field: "CUSER", headerName: "createdby", flex: 1 },
        { field: "SENSORY_ASSESSMENT_ID", headerName: "basi-braden.sensory-assessment", flex: 1 },
        { field: "SKIN_MOISTURE_CONDITION_ID", headerName: "basi-braden.skin-moisture-status", flex: 1 },
        { field: "MOVEMENT_ABILITY_ID", headerName: "basi-braden.movement-ability", flex: 1 },
        { field: "PHYSICAL_ACTIVITY_ID", headerName: "basi-braden.physical-activity", flex: 1 },
        { field: "NUTRITION_ID", headerName: "basi-braden.nutrition", flex: 1 },
        { field: "FRICTION_PRESSURE_ID", headerName: "basi-braden.friction-pressure-irritation", flex: 1 },
        { field: "PERFUSION_OXYGENATION_ID", headerName: "basi-braden.tissue-perfusion-and-oxygenation", flex: 1 },
        { field: "RISK_ASSESSMENT_ID", headerName: "basi-braden.risk-assessment", flex: 1 },
        { field: "CALC_VALUE", headerName: "score", flex: 1 },
        { field: "PRESSURE_WOUND_RATE_ID", headerName: "basi-braden.pressure-sore-rate", flex: 1 },
        { field: "PRESS_SCORE_AREA_ID", headerName: "basi-braden.pressure-sore-area", flex: 1 },
        { field: "IS_BRADEN", headerName: "basi-braden.pressure-sore", flex: 1 },
        { field: "NOTE", headerName: "note", flex: 1 },
    ],
    rows: [
        { title: "PROCESS_TIME", value: "PROCESS_TIME", type: "date" },
        { title: "CUSER", value: "CUSER" },
        { title: "SENSORY_ASSESSMENT_ID", value: "SENSORY_ASSESSMENT_ID_XNAME" },
        { title: "SKIN_MOISTURE_CONDITION_ID", value: "SKIN_MOISTURE_CONDITION_ID_XNAME" },
        { title: "MOVEMENT_ABILITY_ID", value: "MOVEMENT_ABILITY_ID_XNAME" },
        { title: "PHYSICAL_ACTIVITY_ID", value: "PHYSICAL_ACTIVITY_ID_XNAME" },
        { title: "NUTRITION_ID", value: "NUTRITION_ID_XNAME" },
        { title: "FRICTION_PRESSURE_ID", value: "FRICTION_PRESSURE_ID_XNAME" },
        { title: "PERFUSION_OXYGENATION_ID", value: "PERFUSION_OXYGENATION_ID_XNAME" },
        { title: "RISK_ASSESSMENT_ID", value: "RISK_ASSESSMENT_ID_XNAME" },
        { title: "CALC_VALUE", value: "CALC_VALUE" },
        { title: "PRESSURE_WOUND_RATE_ID", value: "PRESSURE_WOUND_RATE_ID_XNAME" },
        { title: "PRESS_SCORE_AREA_ID", value: "PRESS_SCORE_AREA_ID_XNAME" },
        { title: "IS_BRADEN", value: "IS_BRADEN_XNAME" },
        { title: "NOTE", value: "NOTE" },
    ],
};

// Newborn (BBQ)
export const BASI_BRADEN_RISK_SCORE_BBQ = {
    title: "basi-braden.newborn-braden-q-scale",
    masterTableName: "MC_NB_RISK_BRD",
    tableName: "MC_NB_RISK_BRD_DET",
    columnName: "NRB_ID",
    columnValue: 0,
    formData: {
        NRB_ID: "",
        PROCESS_TIME: new Date(),
        NURSE_ID: "",
        GESTATION_TIME_ID: "", // GESTATION_PERIOD_ID
        MOBILITY_NEWBORN_ID: "", // MOBILITY_ID
        ACTIVITY_NEWBORN_ID: "", // ACTIVITY_ID
        SENSORY_PERCEPTION_ID: "", // SENSORY_PERCEPTION_ID
        MOISTURE_CONDITION_ID: "", // HUMIDITY_ID
        FRICTION_PEELING_ID: "", // FRICTION_PEELING_ID
        NUTRITION_NEWBORN_ID: "", // NUTRITION_ID
        PERFUSION_OXYGENATION_ID: "", // PERFUSION_OXYGENATION_ID
        RISK_ASSESSMENT_ID: "",
        CALC_VALUE: "",
        CTIME: new Date(),
        CUSER: "",
        PRESS_SCORE_AREA_ID: "",
        IS_BRADEN: "",
        NOTE: "",
    },
    mcpConfig: {
        GESTATION_TIME_ID: { mcpId: 617, field: "GESTATION_TIME_ID", scoreField: "GESTATION_TIME_SCORE" }, // 617
        MOBILITY_NEWBORN_ID: { mcpId: 618, field: "MOBILITY_NEWBORN_ID", scoreField: "MOBILITY_NEWBORN_SCORE" }, // 618
        ACTIVITY_NEWBORN_ID: { mcpId: 619, field: "ACTIVITY_NEWBORN_ID", scoreField: "ACTIVITY_NEWBORN_SCORE" }, // 619
        SENSORY_PERCEPTION_ID: { mcpId: 620, field: "SENSORY_PERCEPTION_ID", scoreField: "SENSORY_PERCEPTION_SCORE" }, // 620
        MOISTURE_CONDITION_ID: { mcpId: 621, field: "MOISTURE_CONDITION_ID", scoreField: "MOISTURE_CONDITION_SCORE" }, // 621
        FRICTION_PEELING_ID: { mcpId: 622, field: "FRICTION_PEELING_ID", scoreField: "FRICTION_PEELING_SCORE" }, // 622
        NUTRITION_NEWBORN_ID: { mcpId: 623, field: "NUTRITION_NEWBORN_ID", scoreField: "NUTRITION_NEWBORN_SCORE" }, // 623
        PERFUSION_OXYGENATION_ID: { mcpId: 624, field: "PERFUSION_OXYGENATION_ID", scoreField: "PERFUSION_OXYGENATION_SCORE" }, // 624
        RISK_ASSESSMENT_ID: { mcpId: 18, field: "RISK_ASSESSMENT_ID", scoreField: "RISK_ASSESSMENT_ID" }, // 18
        PRESS_SCORE_AREA_ID: { mcpId: 860, field: "PRESS_SCORE_AREA_ID", scoreField: "PRESS_SCORE_AREA_ID" }, // 860
        IS_BRADEN: { mcpId: 859, field: "IS_BRADEN", scoreField: "IS_BRADEN" }, // 859
    },
    fields: [
        { field: "PROCESS_TIME", headerName: "process-time", type: "date", flex: 1 },
        { field: "CUSER", headerName: "createdby", flex: 1 },
        { field: "GESTATION_TIME_ID", headerName: "basi-braden.pregnancy-duration", flex: 1 },
        { field: "MOBILITY_NEWBORN_ID", headerName: "basi-braden.mobility", flex: 1 },
        { field: "ACTIVITY_NEWBORN_ID", headerName: "basi-braden.activity", flex: 1 },
        { field: "SENSORY_PERCEPTION_ID", headerName: "basi-braden.sensory-perception", flex: 1 },
        { field: "MOISTURE_CONDITION_ID", headerName: "basi-braden.moisture", flex: 1 },
        { field: "FRICTION_PEELING_ID", headerName: "basi-braden.friction-peeling", flex: 1 },
        { field: "NUTRITION_NEWBORN_ID", headerName: "basi-braden.nutrition", flex: 1 },
        { field: "PERFUSION_OXYGENATION_ID", headerName: "basi-braden.tissue-perfusion-and-oxygenation", flex: 1 },
        { field: "RISK_ASSESSMENT_ID", headerName: "basi-braden.risk-assessment", flex: 1 },
        { field: "CALC_VALUE", headerName: "score", flex: 1 },
        { field: "PRESS_SCORE_AREA_ID", headerName: "basi-braden.pressure-sore-area", flex: 1 },
        { field: "IS_BRADEN", headerName: "basi-braden.pressure-sore", flex: 1 },
        { field: "NOTE", headerName: "note", flex: 1 },
    ],
    rows: [
        { title: "PROCESS_TIME", value: "PROCESS_TIME", type: "date" },
        { title: "CUSER", value: "CUSER" },
        { title: "GESTATION_TIME_ID", value: "GESTATION_TIME_ID_XNAME" },
        { title: "MOBILITY_NEWBORN_ID", value: "MOBILITY_NEWBORN_ID_XNAME" },
        { title: "ACTIVITY_NEWBORN_ID", value: "ACTIVITY_NEWBORN_ID_XNAME" },
        { title: "SENSORY_PERCEPTION_ID", value: "SENSORY_PERCEPTION_ID_XNAME" },
        { title: "MOISTURE_CONDITION_ID", value: "MOISTURE_CONDITION_ID_XNAME" },
        { title: "FRICTION_PEELING_ID", value: "FRICTION_PEELING_ID_XNAME" },
        { title: "NUTRITION_NEWBORN_ID", value: "NUTRITION_NEWBORN_ID_XNAME" },
        { title: "PERFUSION_OXYGENATION_ID", value: "PERFUSION_OXYGENATION_ID_XNAME" },
        { title: "RISK_ASSESSMENT_ID", value: "RISK_ASSESSMENT_ID_XNAME" },
        { title: "CALC_VALUE", value: "CALC_VALUE" },
        { title: "PRESS_SCORE_AREA_ID", value: "PRESS_SCORE_AREA_ID_XNAME" },
        { title: "IS_BRADEN", value: "IS_BRADEN_XNAME" },
        { title: "NOTE", value: "NOTE" },
    ],
};
